// Register global components

import Vue from 'vue'

import { VPopover } from 'v-tooltip'

Vue.component('v-popover', VPopover)

// Grid
import Container from '@components/BaseComponents/Grid/Container'

Vue.component('container', Container)

// Form
import FormGroup from '@components/BaseComponents/Form/FormGroup'
import BaseInput from '@components/BaseComponents/Form/BaseInput'
import BaseRadio from '@components/BaseComponents/Form/BaseRadio'
import AdvancedInput from '@components/BaseComponents/Form/AdvancedInput'
import BaseTextarea from '@components/BaseComponents/Form/BaseTextarea'
import BaseSelect from '@components/BaseComponents/Form/BaseSelect'
import DropdownSelect from '@components/BaseComponents/Select/DropdownSelect'

Vue.component('form-group', FormGroup)
Vue.component('base-input', BaseInput)
Vue.component('base-radio', BaseRadio)
Vue.component('advanced-input', AdvancedInput)
Vue.component('base-textarea', BaseTextarea)
Vue.component('base-select', BaseSelect)
Vue.component('dropdown-select', DropdownSelect)

// Misc
import Icon from '@components/BaseComponents/Icon'
import BaseButton from '@components/BaseComponents/BaseButton'
import BaseSwitch from '@components/BaseComponents/BaseSwitch'
import BaseRange from '@components/BaseComponents/BaseRange'
import Modal from '@components/BaseComponents/Modal'
import Loader from '@components/BaseComponents/Loader'
import InfoBox from '@components/BaseComponents/InfoBox'
import HelperBox from '@components/BaseComponents/HelperBox'
import Tabs from '@components/BaseComponents/Tabs/Tabs'

Vue.component('btn', BaseButton)
Vue.component('icon', Icon)
Vue.component('base-switch', BaseSwitch)
Vue.component('base-range', BaseRange)
Vue.component('tabs', Tabs)

Vue.component('modal', Modal)

Vue.component('info-box', InfoBox)
Vue.component('helper-box', HelperBox)

Vue.component('loader', Loader)

import ProgressCircle from '@components/BaseComponents/ProgressCircle'

Vue.component('progress-circle', ProgressCircle)
